module.exports = __webpack_public_path__ + "static/media/400135_02.147ced99.png";